// extracted by mini-css-extract-plugin
module.exports = {"Account":"Account_MUM46","AccountTabs":"AccountTabs_oTQYh"};